import momentJalaali from "moment-jalali";
import { Fragment, useRef, useState } from "react";
import { Button, Col, FormGroup, OverlayTrigger, Popover, PopoverContent, PopoverTitle, Row } from "react-bootstrap";
import DatePicker from "react-datepicker2";
import { sendOrDeliverProduct, sendServiceInvoiceSMS, setSignaturePop } from "../../store/api/Services";
import { isWebApp, setErrorDialog, useIsMobileApp } from "../../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";
import { Archive, CheckLg, Clipboard2Check, Envelope, Printer, PrinterFill } from "react-bootstrap-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ServiceDeliverProduct = (props) => {

    const { serviceInfo, checkedIn, setServiceInfo, sendSMSToCustomer, popConsiderDescs, fromModal } = props;
    const history = useHistory();
    const dispatch = useDispatch();
    const isMobile = useIsMobileApp();
    const [isPending, setPending] = useState(false);
    const [submitData, setSubmitData] = useState({
        Date: serviceInfo.SendDeliveryDate ?? momentJalaali().local("en").format("YYYY-MM-DD HH:mm"),
        IsDeliver: Number(serviceInfo.DeliverByID) > 0,
        SendNo: serviceInfo.SendNo,
        SendType: serviceInfo.SendType,
        DeliveredProductTo: serviceInfo.DeliveredProductTo ?? serviceInfo.CustomerName,
        ServiceType: serviceInfo.ServiceType,
        ServiceID: serviceInfo.ServiceID
    });
    const popPrint = (
        <Popover style={{ fontFamily: "Vazir", minWidth: "120px" }}>
            <PopoverTitle className="headerStyle" style={{ padding: "4px 2px", fontSize: "12px" }}><Printer size={17} /> چاپ فاکتور</PopoverTitle>
            <PopoverContent className="bodyStyle" style={{ padding: "2px" }}>
                <div className="popMenuItem" onClick={e => printInvoice("", e.ctrlKey)}><Printer size={16} /> چاپ اول</div>
                <div className="popMenuItem" onClick={e => printInvoice("3", e.ctrlKey)}><PrinterFill size={16} /> چاپ دوم</div>
            </PopoverContent>
        </Popover>
    )
    function onSubmit() {
        setPending(true);
        const onSend = (res) => {
            setPending(false);
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "تحویل/ارسال محصول");
            }
            else if (res.Data) {
                serviceInfo.StageName = "خروج";
                if (submitData.IsDeliver) {
                    serviceInfo.Status = "تحویل شد";
                    serviceInfo.StatusName = "deliveredtocust";
                    serviceInfo.DeliverByID = 1;
                }
                else {
                    serviceInfo.Status = "ارسال شد";
                    serviceInfo.StatusName = "senttocust";
                }
                serviceInfo.SendDeliveryDate = submitData.Date;
                serviceInfo.SendNo = submitData.SendNo;
                serviceInfo.SendType = submitData.SendType;
                serviceInfo.DeliverByID = 0;
                setServiceInfo({ ...serviceInfo });
                setErrorDialog(dispatch, "success", "تحویل/ارسال محصول");
                sendSMSToCustomer();
            }
        }
        sendOrDeliverProduct(submitData, onSend);
    }
    function printInvoice(number, ctrlKey) {
        const showPrint = () => {
            history.push({
                pathname: `/PrintViewer/ServiceInvoice${number}/${ctrlKey}`,
                state: {
                    dataUrl: `ReceptionTasksApi/GetServiceInvoice?serviceID=${serviceInfo.ServiceID}&serviceType=${serviceInfo.ServiceType}`,
                    method: "get"
                }
            });
        }
        if (!ctrlKey && !serviceInfo.HasInvoiceSignature) {
            dispatch(setSignaturePop({
                show: true, parentID: serviceInfo.ServiceID, parentType: serviceInfo.ServiceType + "invoice",
                onSave: showPrint,
                onClose: showPrint
            }))
        }
        else {
            showPrint();
        }
    }
    function printInvoice2(e) {
        const showPrint = () => {
            history.push({
                pathname: "/PrintViewer/ServiceInvoice2/" + e.ctrlKey,
                state: {
                    dataUrl: `ReceptionTasksApi/GetServiceTotalCost?serviceID=${serviceInfo.ServiceID}&serviceType=${serviceInfo.ServiceType}`,
                    method: "get"
                }
            });
        }
        if (!e.ctrlKey && !serviceInfo.HasInvoiceSignature) {
            dispatch(setSignaturePop({
                show: true, parentID: serviceInfo.ServiceID, parentType: serviceInfo.ServiceType + "invoice",
                onSave: showPrint,
                onClose: showPrint
            }))
        }
        else {
            showPrint();
        }

    }
    return (
        <Row style={{ textAlign: "right" }}>
            <Col md={6} style={{ maxWidth: "max-content" }} className="mt-2 rowBorder">
                <table>
                    <tbody>
                        <tr>
                            <td style={{ width: "120px", fontWeight: "bold" }}>مشخصات محصول: </td>
                            <td>{(serviceInfo.HolderName ? serviceInfo.HolderName + "-" : "") + (serviceInfo.ProductName ? serviceInfo.ProductName + '-' : "") + (serviceInfo.ProductModel ?? "")}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "120px", fontWeight: "bold" }}>سریال محصول: </td>
                            <td style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }}>{serviceInfo.SerialNumber}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "120px", fontWeight: "bold" }}>نام مشتری:</td>
                            <td>{serviceInfo.CustomerName}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "120px", fontWeight: "bold" }}>شماره تماس مشتری:</td>
                            <td>{(serviceInfo.CustomerMobile ? (serviceInfo.CustomerMobile + ",") : '') + (serviceInfo?.CustomerPhone ?? '')}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "120px", fontWeight: "bold" }}>نشانی مشتری:</td>
                            <td>{serviceInfo.ServiceAddress}</td>
                        </tr>
                    </tbody>
                </table>
            </Col>
            <Col md={3} className="rowBorder mt-2">
                <table style={{ width: "100%" }}>
                    <tbody>
                        <tr>
                            <td style={{ fontWeight: "bold" }}>هزینه سرویس: </td>
                            <td>{submitData.InitPay ? submitData.InitPay.toLocaleString() : 0}</td>
                        </tr>
                        <tr>
                            <td style={{ fontWeight: "bold" }}>تخفیف: </td>
                            <td>{submitData.Discount ? submitData.Discount.toLocaleString() : 0}</td>
                        </tr>
                        <tr>
                            <td style={{ fontWeight: "bold" }}>مالیات: </td>
                            <td>{submitData.TaxAmount ? submitData.TaxAmount.toLocaleString() : 0}</td>
                        </tr>
                        <tr>
                            <td style={{ fontWeight: "bold" }}>قابل پرداخت: </td>
                            <td>{submitData.AmountCustomerShouldPay ? submitData.AmountCustomerShouldPay.toLocaleString() : 0}</td>
                        </tr>
                        <tr>
                            <td style={{ fontWeight: "bold" }}><label className="ellipsisLabel">دریافتی از مشتری: </label></td>
                            <td>
                                {serviceInfo?.CustomerPayment ? serviceInfo?.CustomerPayment.toLocaleString() : 0}
                            </td>
                            <td>
                                {serviceInfo?.TargetAccountName ?? ""}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ fontWeight: "bold" }}>بیعانه: </td>
                            <td>{serviceInfo.Deposit ? serviceInfo.Deposit.toLocaleString() : 0}</td>
                            <td>
                                {serviceInfo?.AccountName4Deposit ?? ""}
                            </td>

                        </tr>
                    </tbody>
                </table>
            </Col>
            <Col md={4} className="rowBorder mt-2" style={{ paddingTop: "3px" }}>
                <table>
                    <tbody>
                        <tr>
                            <td>نوع خروج:</td>
                            <td>
                                <select className="form-control tableRowInput" onChange={e => setSubmitData({ ...submitData, IsDeliver: e.target.value })} defaultValue={submitData.IsDeliver}>
                                    <option value={false}>ارسال</option>
                                    <option value={true}>تحویل</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td>{submitData.IsDeliver?.toString() === "true" ? "تاریخ تحویل:" : "تاریخ ارسال:"}</td>
                            <td>
                                <DatePicker className="form-control tableRowInput mt-0" isGregorian={false} timePicker={true} inputJalaaliFormat="jYYYY/jMM/jDD HH:mm" value={submitData.Date ? momentJalaali(submitData.Date) : null} onChange={value => setSubmitData({ ...submitData, Date: value.local("en").format("YYYY-MM-DD HH:mm") })} />
                            </td>
                        </tr>
                        {submitData.IsDeliver?.toString() !== "true" &&
                            <Fragment>
                                <tr>
                                    <td>نحوه ارسال:</td>
                                    <td>
                                        <select className="form-control tableRowInput" onChange={e => submitData.SendType = e.target.value} defaultValue={submitData.SendType ?? ""}>
                                            <option value="پست عادی">پست عادی</option>
                                            <option value="پست پیشتاز">پست پیشتاز</option>
                                            <option value="باربری">باربری</option>
                                            <option value="تیپاکس">تیپاکس</option>
                                            <option value="چاپار">چاپار</option>
                                            <option value="">سایر</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>شماره مرسوله:</td>
                                    <input className="tableRowInput" onChange={e => submitData.SendNo = e.target.value} defaultValue={submitData.SendNo} />
                                </tr>
                            </Fragment>
                        }
                        <tr>
                            <td>تحویل گیرنده:</td>
                            <td><input className="tableRowInput" onChange={e => submitData.DeliveredProductTo = e.target.value} defaultValue={submitData.DeliveredProductTo} /></td>
                        </tr>
                        {submitData.SendOrDeliverByName?.length > 0 &&
                            <tr>
                                <td>{submitData.IsDeliver?.toString() !== "true" ? "ارسال کننده" : "تحویل گیرنده"}:</td>
                                <td>{submitData.SendOrDeliverByName}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </Col>
            <Row style={{ textAlign: "right" }} className="mt-3">
                <div>
                    <Button variant="success" className="group-Btn" onClick={onSubmit} disabled={isPending || serviceInfo.IsArchive || serviceInfo.StoppedInStatus}><CheckLg size={18} /> ثبت خروج</Button>
                    <OverlayTrigger overlay={popPrint} trigger="click">
                        <Button className="group-Btn" title="چاپ فاکتور(با جزئیات)" style={{ fontSize: "12px" }}><Printer size={18} />&nbsp;{!isMobile && "چاپ فاکتور(با جزئیات)"}</Button>
                    </OverlayTrigger>
                    <Button variant="secondary" title="چاپ فاکتور(بدون جزئیات)" className="group-Btn" style={{ fontSize: "12px" }} onClick={(e) => printInvoice2(e)}><Printer size={18} />&nbsp;{!isMobile && "چاپ فاکتور(بدون جزئیات)"}</Button>
                    <Button className="group-Btn" style={{ fontSize: "12px" }} onClick={() => { sendServiceInvoiceSMS(serviceInfo.ServiceType, serviceInfo.ServiceID, serviceInfo.CustomerMobile); }}><Envelope size={18} />&nbsp;{!isMobile && 'پیامک لینک فاکتور'}</Button>
                    {!fromModal &&
                        <OverlayTrigger overlay={popConsiderDescs} rootClose trigger="click">
                            <Button className="group-Btn" variant='info' disabled={serviceInfo.StoppedInStatus}><Clipboard2Check size={19} /> شرح رسیدگی</Button>
                        </OverlayTrigger>
                    }
                </div>
            </Row>
        </Row>
    )
}
export default ServiceDeliverProduct;